export default __webpack_public_path__ + "static/media/image2.fcf0646c.jpg";